import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialogs-buscador-externa',
  templateUrl: './dialogs-buscador-externa.component.html',
  styleUrls: ['./dialogs-buscador-externa.component.scss']
})
export class DialogsBuscadorExternaComponent implements OnInit {

  tramitsbusqueda: string = "";

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: boolean,
              @Optional() private dialogRef: MatDialogRef<DialogsBuscadorExternaComponent>) { }

  ngOnInit() {
  }

  cargarTramitsYCarpeta(){
    this.dialogRef.close(this.tramitsbusqueda);
  }

}
